// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
Vue.use(MintUI)
import 'mint-ui/lib/style.css'
import '../static/style.css'
import wx from 'weixin-js-sdk'
//vuex
import store from '@/vuex/store'
//axios
import axios from 'axios';
import 'url-search-params-polyfill';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js